import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from "@angular/core";

import { FormsModule } from "@angular/forms";

import { NgbDate, NgbDatepickerModule } from "@ng-bootstrap/ng-bootstrap";

import { environment } from "../../../../environments/environment";

@Component({
  selector: "glo-date-control",
  standalone: true,
  imports: [NgbDatepickerModule, FormsModule],
  templateUrl: "./glo-date-control.component.html",
  styleUrls: ["./glo-date-control.component.scss"],
})
export class GloDateControl implements OnInit, OnChanges {
  @Input()
  value: string | null = null;

  @Output()
  dateChange = new EventEmitter<string>();

  model: NgbDate | null = null;

  assetUrl = environment.assetBaseUrl;

  ngOnInit(): void {
    /*
     * If the parent supplied a date,
     * display that date.
     */
    if (this.value) {
      this.applyValue(this.value);

      return;
    }

    /*
     * Otherwise default to today.
     */
    const today = new Date();

    this.model = new NgbDate(
      today.getFullYear(),
      today.getMonth() + 1,
      today.getDate(),
    );

    /*
     * Tell the parent what the default
     * date actually is.
     */
    this.emitDate(this.model);
  }

  ngOnChanges(changes: SimpleChanges): void {
    /*
     * This handles dates arriving from
     * query parameters after initialization.
     *
     * IMPORTANT:
     * We update the displayed model here,
     * but do NOT emit it back out.
     */
    if (changes["value"] && this.value) {
      this.applyValue(this.value);
    }
  }

  onDateSelected(date: NgbDate): void {
    /*
     * Explicit user selection.
     *
     * Update the local picker model...
     */
    this.model = new NgbDate(date.year, date.month, date.day);

    /*
     * ...and explicitly tell the parent
     * SearchComponent about the new date.
     */
    this.emitDate(this.model);
  }

  get formattedDate(): string {
    if (!this.model) {
      return "";
    }

    return this.toIsoDate(this.model.year, this.model.month, this.model.day);
  }

  private emitDate(date: NgbDate): void {
    this.dateChange.emit(this.toIsoDate(date.year, date.month, date.day));
  }

  private applyValue(value: string): void {
    const match = value.match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/);

    if (!match) {
      return;
    }

    this.model = new NgbDate(
      Number(match[1]),
      Number(match[2]),
      Number(match[3]),
    );
  }

  private toIsoDate(year: number, month: number, day: number): string {
    return [
      String(year),

      String(month).padStart(2, "0"),

      String(day).padStart(2, "0"),
    ].join("-");
  }
}
